import { useContext, useEffect } from 'react'

import { Box, Text } from '@fairfashion/design-system'

import { Documents } from '../../../../components/Documents/documents.comp'
import { ProviderContext } from '../../provider.context'

export const ProviderDocuments = () => {
  const { documents, actions } = useContext(ProviderContext)
  useEffect(() => {
    actions.getDocuments()
  }, [])

  return documents && documents.length > 0 ? (
    <Documents documents={documents} />
  ) : (
    <Box alignItems="center" justifyContent="center" width="100%" padding={6}>
      <Text align="center">Não há documentos cadastrados</Text>
    </Box>
  )
}
